import React from 'react';
import { Popover } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import Colors from '../constants/Colors';

export default function EquipmentOverrideWarningPopover({
  title,
  showWarning = false,
  content,
}) {
  return (
    <div>
      {title}
      { !!showWarning && (
        <Popover
          content={content}
          title="Warning"
          trigger="hover"
          placement="bottomLeft"
        >
          <WarningOutlined
            style={{
              color: Colors.ONTRACCR_DARK_YELLOW,
              marginLeft: 10,
              marginBottom: 1,
            }}
          />
        </Popover>
      )}
    </div>
  );
}

EquipmentOverrideWarningPopover.propTypes = {
  title: PropTypes.string.isRequired,
  showWarning: PropTypes.bool,
  content: PropTypes.node.isRequired,
};

EquipmentOverrideWarningPopover.defaultProps = {
  showWarning: false,
};